import {
    Component,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { fromEvent, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { marketingNavigation } from '@fuse/components/navigation/vertical/navigations';
import { ApiService } from 'app/core/services/api.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'app/core/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'environments/environment';

@Component({
    selector: 'dense-layout',
    templateUrl: './dense.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class DenseLayoutComponent implements OnInit, OnDestroy {

    isScreenSmall: boolean;
    navigation: any;
    navigationAppearance: 'default' | 'dense' = 'dense';
    partnerachUrl = environment.partnerachUrl;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    settingsData: any;
    activeModule: any;
    profileData: any;
    activeParam: any;
    activeLanguage: string;
    closedOnboarding: boolean = false;
    allLanguages: any = [
        { name: 'English', icon: 'english_icon', value: 'en' },
        { name: 'German', icon: 'german_icon', value: 'de' },
        { name: 'French', icon: 'french_icon', value: 'fr' },
        { name: 'Spanish', icon: 'spanish_icon', value: 'es' },
    ];
    translateData: any;
    item: any;
    isConnectionAlert: boolean = false;
    connectionStatus: string = '';
    onlineEvent: Observable<Event>;
    offlineEvent: Observable<Event>;
    subscriptions: Subscription[] = [];
    isExpired: boolean;
    workspaceData: FormGroup;
    submitted: boolean = false;
    workSpacePasswordType: any = 'password';
    workSpacePasswordView: boolean = false;
    workspaceId: any;
    workspaceList: any = [];
    loadingText: any = '';
    cLoading: boolean = false;
    isWorkSpaceAPICalled: any;
    activatedPlan: any;
    isStepsVisible: boolean = false;
    stepsData: any;
    imagePathSrc: any;
    completedStepsValue: any;
    @ViewChild('welcomeModal') welcomeModal: TemplateRef<any>;
    welcomeLoader: boolean;
    isWidgetOpened: boolean = false;
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private api: ApiService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private authService: AuthService,
        private translateSer: TranslateService,
        private formBuilder: FormBuilder,
    ) {
        this.translateSer.get('MENU').subscribe((res) => {
            this.translateData = res;
        });
        this.imagePathSrc = '/assets/images/';
        this.matIconRegistry
            .addSvgIcon(
                'tick',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    this.imagePathSrc + 'dashboard-onboarding/tick-icon.svg'
                )
            )
            .addSvgIcon(
                'tick-normal',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    this.imagePathSrc + 'dashboard-onboarding/tick-normal.svg'
                )
            );

        this.authService.currentUser
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (res: any) => {
                    if (res && res != null) {
                        this.profileData = res;
                        if (res && res.language) {
                            switch (res.language) {
                                case 'en':
                                    this.activeLanguage = 'en';
                                    break;
                                case 'es':
                                    this.activeLanguage = 'es';
                                    break;
                                case 'fr':
                                    this.activeLanguage = 'fr';
                                    break;
                                case 'de':
                                    this.activeLanguage = 'de';
                                    break;

                                default:
                                    this.activeLanguage = 'en';
                                    break;
                            }
                        }
                    }
                },
            });

        this.api.currentPlanLoaded.subscribe({
            next: (res: boolean) => {
                if (res == true) {
                    this.activatedPlan = this.api.activatedPlan;
                }
            },
        });

        this._router.events.subscribe((event: any) => {
            if (event.routerEvent instanceof NavigationEnd) {
                this.activeParam = event.routerEvent.url;
            }
        });

        this.workspaceData = this.formBuilder.group({
            domain: ['', Validators.required],
            email: ['', Validators.required],
            password: ['', Validators.required],
        });

        let sidebarData;
        sidebarData = marketingNavigation;
        sidebarData.forEach((data) => {
            data.isVisible = true;
        });
        console.log('sidebar data', sidebarData);
        setTimeout(() => {
            sidebarData.forEach((data) => {
                if (data.tooltip && data.tooltipKey) {
                    data.tooltip = this.translateData[data.tooltipKey];
                    console.log('this.translateData', this.translateData);
                }
            });
        }, 100)
        this.navigation = sidebarData;

        this.onlineEvent = fromEvent(window, 'online');
        this.offlineEvent = fromEvent(window, 'offline');

        this.subscriptions.push(
            this.onlineEvent.subscribe((e) => {
                this.connectionStatus = 'connecting';
                setTimeout(() => {
                    this.connectionStatus = 'online';
                }, 1500);
                setTimeout(() => {
                    this.isConnectionAlert = false;
                }, 3000);
                console.log('Online...');
            })
        );

        this.subscriptions.push(
            this.offlineEvent.subscribe((e) => {
                this.isConnectionAlert = true;
                this.connectionStatus = 'offline';
                console.log('Offline...');
            })
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // this.navigation = defaultNavigation
        this.api.isLoadSettings
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: boolean) => {
                if (response == true) {
                    this.settingsData = this.api.settingsData;
                    console.log('settings data', this.settingsData);
                }
            });

        this.api.isSubscriptionOver.subscribe({
            next: (res: boolean) => {
                if (res == true) {
                    this.isExpired = true;
                } else {
                   
                }
            },
        });

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
               
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');

                // Change the navigation appearance
                this.navigationAppearance = this.isScreenSmall
                    ? 'default'
                    : 'dense';
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.subscriptions.forEach((subscription) =>
            subscription.unsubscribe()
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    /**
     * Toggle the navigation appearance
     */
    toggleNavigationAppearance(): void {
        this.navigationAppearance =
            this.navigationAppearance === 'default' ? 'dense' : 'default';
    }

    updateLangauge(lan) {
        this.api.getData('language/' + lan).subscribe((res: any) => {
            console.log(res);
            if (lan != localStorage.getItem('language')) {
                localStorage.setItem('language', lan);
                window.location.reload();
            }
        });
    }

    /**
     * Sign out
     */
    signOut(): void {
        const fd = new FormData()
        if (localStorage.getItem("devicetoken")) {
            fd.append("web_device_token", localStorage.getItem("devicetoken"));
        }
        fd.append
        this.api.postData("logout", fd).subscribe(
            (res: any) => {
                if (res) {
                    this.api.isLoggedOut.next(1);
                }
            },
            (err) => console.log("err", err)
        );
        setTimeout(() => {
            this.api.isLogginFirstTime.next(false);
            localStorage.removeItem("token");
            //  ! this.lan.setLanguage("en");
            localStorage.setItem("language", "en");
            localStorage.removeItem("currentUser");
            this.authService.logout();
        }, 500);
        this.api.setBaseUrl();
        this._router.navigate(['/sign-out']);
    }
}
